import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=5d36398c&scoped=true"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ViewSwitcher.vue?vue&type=style&index=0&id=5d36398c&prod&scoped=true&lang=scss"
import style1 from "./ViewSwitcher.vue?vue&type=style&index=1&id=5d36398c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d36398c",
  null
  
)

export default component.exports